import { render, staticRenderFns } from "./ArtworksActionsBar.vue?vue&type=template&id=2d44fc68&scoped=true"
import script from "./ArtworksActionsBar.vue?vue&type=script&lang=js"
export * from "./ArtworksActionsBar.vue?vue&type=script&lang=js"
import style0 from "./ArtworksActionsBar.vue?vue&type=style&index=0&id=2d44fc68&prod&lang=less&scoped=true"
import style1 from "./ArtworksActionsBar.vue?vue&type=style&index=1&id=2d44fc68&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44fc68",
  null
  
)

export default component.exports